<template>
  <div>
    <div v-if="!loadStatus">
      <Skeleton width="100%" height="3.5rem" v-for="i in 15" :key="i" />
    </div>
    <template v-if="loadStatus">
      <InventoryNotification
        :showModel="toggleModelDisplay"
        v-if="!Number(stockThresholdLimit)"
      />
      <StockthresholdNotification :showModel="toggleModelDisplay" v-else />
      <InventoryAlert v-if="isBelowThreshold" />
      <InventoryButtons
        :isReplenishProducts="isReplenishProducts"
        :productsToReplenish="productsToReplenish"
      />
      <div v-if="productinventoryList.length">
        <InventoryNotificationsBanner v-if="false" />
        <vue-good-table
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          :columns="columns"
          :rows="groupedInventoryList"
          styleClass="vgt-table striped"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm
          }"
        >
          <template slot="table-column" slot-scope="productinventoryList">
            <span
              v-if="
                productinventoryList.column.field === 'replenish' &&
                  hasThresholdValue
              "
              class="flex justify-end items-center"
            >
              <button
                @click="replenishProducts"
                class="button-gemnote button-gemnote--small restock-small"
                :disabled="!productsToReplenish.length"
              >
                <span>Request restock</span>
              </button>
            </span>
          </template>
          <template slot="table-row" slot-scope="productinventoryList">
            <InventoryTableCell
              :column="productinventoryList.column"
              :row="productinventoryList.row"
              :show-variants="showVariants[productinventoryList.row.id]"
              @toggle-variants="toggleVariants(productinventoryList.row.id)"
              @update-quantity="updateRowQuantity"
              @toggle-single-replenish="toggleSingleReplenish"
              @toggle-check-all="toggleCheckAll"
              @toggle-variant-replenish="toggleVariantReplenish"
              @set-variant-replenish-quantity="setVariantReplenishQuantity"
            />
          </template>
        </vue-good-table>
      </div>
      <div v-else>
        <ProductInventoryZeroState />
      </div>
    </template>
    <Pagination
      :total-items="totalRecords"
      :page="serverParams.page"
      :items-per-page="serverParams.perPage"
      @page-change="pageChange"
      @perPageChange="handlePerPageChange"
    />
    <StockThresholdModal
      :showFooter="true"
      :showCancelButton="false"
      v-show="isModelActive"
      colorVariation="coast"
      buttonLabel="SET"
      @hideModal="toggleModelDisplay"
      @confirmAction="handleSetStockThreshold"
      :isConfirmButtonActive="!thresholdValue || isLoading"
    >
      <template slot="header">
        <span>Stock Threshold</span>
      </template>

      <template slot="body">
        <span
          >Add a threshold value for your stock and get notifications when any
          item in your inventory falls below the threshold value. You can change
          this at any time.
        </span>
        <div class="stock-container">
          <label class="stock-label">Stock threshold</label>
          <input class="stock-input" type="number" v-model="thresholdValue" />
        </div>
      </template>
    </StockThresholdModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { progressStatus, scrollPageToTop } from '../../helpers'
import { VueGoodTable } from 'vue-good-table'
import Util from '../../mixins/Util'
import InventoryButtons from './Sections/InventoryButtons.vue'
import InventoryNotification from './Sections/InventoryNotification.vue'
import InventoryAlert from './Sections/InventoryAlert.vue'
import StockthresholdNotification from './Sections/StockthresholdNotification.vue'
export default {
  name: 'ProductInventory',
  mixins: [Util],
  components: {
    VueGoodTable,
    InventoryButtons,
    InventoryNotification,
    InventoryAlert,
    StockthresholdNotification,
    InventoryTableCell: () => import('./Sections/InventoryTableCell.vue'),
    StockThresholdModal: () => import('@/components/Universal/Modal'),
    ProductInventoryZeroState: () =>
      import('@/components/Inventory/ProductInventoryZeroState'),
    Skeleton: () => import('@/components/Universal/Skeleton'),
    Pagination: () => import('@/components/Universal/Pagination'),
    InventoryNotificationsBanner: () =>
      import('@/components/Inventory/InventoryNotificationsBanner')
  },
  data() {
    return {
      serverParams: {
        page: 0,
        perPage: 50
      },
      titleSortDirection: 'ASC',
      sizeSortDirection: 'ASC',
      columns: [
        {
          label: 'Product',
          field: 'image',
          width: '150px',
          sortable: false
        },
        {
          label: 'Product Title',
          field: 'title',
          sortable: true,
          thClass: 'sortable sort-asc',
          sortFn: this.customSort
        },
        {
          label: 'Size',
          field: 'size',
          width: '100px',
          sortable: true,
          thClass: 'sortable',
          sortFn: this.customSort
        },
        {
          label: 'Quantity',
          field: 'quantity',
          width: '100px',
          sortable: false
        },
        {
          label: 'Item Cost',
          field: 'cost',
          width: '100px',
          hidden: !this.showPrices(),
          sortable: false
        },
        {
          label: 'Restock Item ',
          field: 'replenish',
          width: '140px',
          sortable: false
        }
      ],
      showVariants: {},
      isModelActive: false,
      thresholdValue: 0,
      isLoading: false
    }
  },
  async created() {
    await this.getProductsInventory({
      sortBy: 'sort_product_name',
      sortDirection: this.titleSortDirection,
      page: 1,
      perPage: this.serverParams.perPage
    })
    this.handleProductsBelowThreshold()
    this.thresholdValue = this.stockThresholdLimit
  },
  methods: {
    async handleSetStockThreshold() {
      this.isLoading = true
      await this.$store.dispatch(
        'inventory/setStockThresholdLimit',
        this.thresholdValue
      )
      this.isLoading = false
      this.toggleModelDisplay()
      await this.getProductsInventory({
        sortBy: 'sort_product_name',
        sortDirection: this.titleSortDirection,
        page: 1,
        perPage: this.serverParams.perPage,
        showLoader: false
      })
    },
    ...mapActions('inventory', ['getProductsInventory']),
    handleExport() {
      this.$store.dispatch('modal/handleExports', 'team_inventory')
    },
    toggleModelDisplay() {
      this.isModelActive = !this.isModelActive
    },
    updateProductReplenishQuantity(event, row, quantity) {
      this.$store.dispatch('inventory/updateProductReplenishQuantity', {
        id: parseInt(row.id),
        originalIndex: row.originalIndex,
        quantity: quantity
      })
      if (Number(quantity) >= Number(this.stockThresholdValue)) {
        this.$store.commit('inventory/UPDATE_PRODUCT_REPLENISH_ERROR', {
          originalIndex: row.originalIndex,
          error: false
        })
      }
    },
    async replenishProducts() {
      // this.groupedInventoryList.filter(group => group.replenish)
      for (let i = 0; i < this.productsToReplenish.length; i++) {
        // return expiry date due logic

        // const replenishProduct = this.productsToReplenish[i]

        // if (replenishProduct.expirationDate) {
        //   const expirationDate = new Date(replenishProduct.expirationDate)
        //   const currentDate = new Date()

        //   // Calculate date 2 days from now
        //   const threeDaysFromNow = new Date()
        //   threeDaysFromNow.setDate(currentDate.getDate() + 2)

        //   if (expirationDate < currentDate) {
        //     this.$store.dispatch('notification/pushNotification', {
        //       title: replenishProduct.title,
        //       type: 'warning',
        //       messages: [
        //         `This product has a limited shelf life and expired on ${this.formatDate(
        //           expirationDate
        //         )}. Please exercise discretion when placing an order.`
        //       ]
        //     })
        //     return
        //   } else if (expirationDate <= threeDaysFromNow) {
        //     this.$store.dispatch('notification/pushNotification', {
        //       title: replenishProduct.title,
        //       type: 'warning',
        //       messages: [
        //         `This product has a limited shelf life and will expire on ${this.formatDate(
        //           expirationDate
        //         )}. Please exercise discretion when placing an order.`
        //       ]
        //     })
        //     return
        //   }
        // }
        // return expiry date due logic

        const productVariants = this.productsToReplenish[i]
          .sortedProductVaraints

        if (productVariants && productVariants.length > 1) {
          productVariants.forEach((variant, index) => {
            if (variant.replenish && Number(variant.replenishQuantity) <= 0) {
              this.$store.commit('inventory/UPDATE_PRODUCT_REPLENISH_ERROR', {
                originalIndex: this.productinventoryList.findIndex(
                  product => product.id === this.productsToReplenish[i].id
                ),
                error: true,
                variantIndex: index
              })
              return
            } else {
              this.$store.commit('inventory/UPDATE_PRODUCT_REPLENISH_ERROR', {
                originalIndex: this.productinventoryList.findIndex(
                  product => product.id === this.productsToReplenish[i].id
                ),
                error: false,
                variantIndex: index
              })
            }
          })
        } else {
          if (Number(this.productsToReplenish[i].replenishQuantity) <= 0) {
            this.$store.commit('inventory/UPDATE_PRODUCT_REPLENISH_ERROR', {
              originalIndex: this.productinventoryList.findIndex(
                product =>
                  product.id === this.productsToReplenish[i].id &&
                  product.variantName ===
                    this.productsToReplenish[i].variantName
              ),
              error: true
            })
            return
          } else {
            this.$store.commit('inventory/UPDATE_PRODUCT_REPLENISH_ERROR', {
              originalIndex: this.productinventoryList.findIndex(
                product =>
                  product.id === this.productsToReplenish[i].id &&
                  product.variantName ===
                    this.productsToReplenish[i].variantName
              ),
              error: false
            })
          }
        }
      }

      const hasErrors = this.productsToReplenish.some(product => {
        if (product.sortedProductVaraints.length > 1) {
          return product.sortedProductVaraints.some(
            variant =>
              variant.replenish &&
              (Number(variant.replenishQuantity) <= 0 ||
                variant.replenishQuantityError)
          )
        }
        return (
          Number(product.replenishQuantity) <= 0 ||
          product.replenishQuantityError
        )
      })

      if (hasErrors) {
        return
      } else {
        await this.$store.dispatch('inventory/replenishProducts')
        await this.getProductsInventory({
          sortBy: 'sort_product_name',
          sortDirection: this.titleSortDirection,
          page: 1,
          perPage: this.serverParams.perPage,
          showLoader: false
        })
      }
    },
    showPrices() {
      return this.$store.getters['team/showPrices']
    },
    onPageChange() {
      scrollPageToTop()
    },
    pageChange(page) {
      this.updateParams({ page })
      this.getNextChunkOfInventory()
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },
    handlePerPageChange(e) {
      this.serverParams.perPage = e
      this.getNextChunkOfInventory()
    },
    getNextChunkOfInventory() {
      this.getProductsInventory({
        page: this.serverParams.page + 1,
        perPage: this.serverParams.perPage,
        sortBy: 'sort_product_name',
        sortDirection: this.titleSortDirection
      })
      this.handleProductsBelowThreshold()
    },
    handleProductsBelowThreshold() {
      if (this.stockThresholdValue) {
        this.productinventoryList.forEach((product, index) => {
          if (Number(product.quantity) < Number(this.stockThresholdValue)) {
            this.$store.dispatch('inventory/addProductToReplenish', {
              id: parseInt(product.id),
              originalIndex: index
            })
          }
        })
      }
    },
    onSortChange(params) {
      const sortedOptions = params[0]
      const index = this.columns.findIndex(
        column => column.field === sortedOptions.field
      )
      this.columns.forEach(
        column => (column.thClass = column.sortable ? 'sortable' : '')
      )

      if (sortedOptions.field === 'title') {
        this.titleSortDirection =
          this.titleSortDirection === 'ASC' ? 'DESC' : 'ASC'
        this.columns[index].thClass +=
          this.titleSortDirection === 'ASC' ? ' sort-asc' : ' sort-desc'
        this.getProductsInventory({
          sortBy: 'sort_product_name',
          sortDirection: this.titleSortDirection
        })
      } else if (sortedOptions.field === 'size') {
        this.sizeSortDirection =
          this.sizeSortDirection === 'ASC' ? 'DESC' : 'ASC'
        this.columns[index].thClass +=
          this.sizeSortDirection === 'ASC' ? ' sort-asc' : ' sort-desc'
        this.getProductsInventory({
          sortBy: 'sort_size',
          sortDirection: this.sizeSortDirection
        })
      }
    },
    customSort() {
      return false
    },
    toggleVariants(rowId) {
      let variantRowId = null
      if (Object.keys(rowId).length > 1) {
        variantRowId = rowId
      } else {
        variantRowId = rowId
      }
      this.$set(
        this.showVariants,
        variantRowId,
        !this.showVariants[variantRowId]
      )
    },
    // eslint-disable-next-line no-unused-vars
    addProductToReplenish(event, item, row) {},
    toggleCheckAll(event, row) {
      const isChecked = event.target.checked
      row.sortedProductVaraints.forEach((variant, index) => {
        this.$set(row.sortedProductVaraints[index], 'replenish', isChecked)
        if (isChecked) {
          this.$set(
            row.sortedProductVaraints[index],
            'quantity',
            row.sortedProductVaraints[index].quantity || 1
          )
        } else this.$set(row.sortedProductVaraints[index], 'quantity', null)
        this.$store.commit('inventory/ADD_PRODUCT_TO_REPLENISH', {
          id: parseInt(row.id),
          originalIndex: row.originalIndex,
          quantity: row.replenishQuantity,
          replenish: event.target.checked,
          row: row,
          variant: row.sortedProductVaraints[index]
        })
      })
    },
    toggleVariantReplenish(event, variant, index, row) {
      this.$store.commit('inventory/ADD_PRODUCT_TO_REPLENISH', {
        id: parseInt(row.id),
        originalIndex: row.originalIndex,
        quantity: row.replenishQuantity,
        replenish: event.target.checked,
        row: row,
        variant: variant
      })
    },
    setVariantReplenishQuantity(event, variant, index, row) {
      const quantity = event.target.value
      const currentVariant = row.sortedProductVaraints[index]
      const variants = row.sortedProductVaraints
      const currentVariantIndex = variants.findIndex(v => v.id == variant)

      if (currentVariantIndex !== -1) {
        variants[currentVariantIndex].replenish = true
      }

      // Add variant to replenish list with specific variant identification
      this.$store.commit('inventory/ADD_PRODUCT_TO_REPLENISH', {
        id: parseInt(row.id),
        originalIndex: row.originalIndex,
        quantity: quantity,
        variantId: currentVariant.variantId, // Use current variant specifically
        variantName: currentVariant.variantName,
        isVariant: true,
        variantIndex: index,
        replenish: true,
        variants: variants
      })

      // Update quantity in store for specific variant
      this.$store.dispatch('inventory/updateProductReplenishQuantity', {
        id: parseInt(row.id),
        originalIndex: row.originalIndex,
        quantity: quantity,
        variantId: variant,
        variantName: currentVariant.variantName,
        isVariant: true,
        variantIndex: index,
        needsReplenish: currentVariant.needsReplenish,
        replenishQuantityError: currentVariant.replenishQuantityError,
        cost: currentVariant.cost,
        replenish: currentVariant.replenish
      })
      //
      // // Update only the specific variant in the local state
      this.$set(row.sortedProductVaraints[index], 'replenishQuantity', quantity)
    },
    toggleSingleReplenish(event, row) {
      let variantId = ''
      if (row.sortedProductVaraints.length) {
        variantId = row.sortedProductVaraints[0].id
      }
      this.$store.commit('inventory/ADD_PRODUCT_TO_REPLENISH', {
        id: parseInt(row.id),
        originalIndex: row.originalIndex,
        quantity: row.replenishQuantity,
        replenish: !row.replenish,
        variantId: variantId
      })
    },
    updateRowQuantity(row) {
      this.$store.dispatch('inventory/updateProductReplenishQuantity', {
        id: parseInt(row.id),
        originalIndex: row.originalIndex,
        quantity: row.replenishQuantity
      })
    }
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadingProductInventory)
    },
    isBelowThreshold() {
      return this.productinventoryList.some(product =>
        product.sortedProductVaraints.some(varient => varient.belowThreshold)
      )
    },
    productsToReplenish() {
      return this.$store.getters['inventory/productsToReplenish']
    },
    groupedInventoryList() {
      const groupedInventoryList = Object.values(
        this.productinventoryList.reduce((acc, item) => {
          if (!acc[item.id])
            acc[item.id] = {
              id: item.id,
              title: item.title.split(' - ')[0],
              image: item.image,
              totalCost: 0,
              totalQuantity: 0,
              variants: [],
              sortedProductVaraints: item.sortedProductVaraints,
              size: '',
              replenish: item.replenish,
              replenishQuantity: item.replenishQuantity,
              replenishQuantityError: item.replenishQuantityError,
              belowThreshold: item.belowThreshold,
              expirationDate: item.expirationDate
            }
          acc[item.id].size =
            acc[item.id].sortedProductVaraints.length > 1
              ? 'Multiple'
              : acc[item.id].sortedProductVaraints.length > 0 &&
                (acc[item.id].sortedProductVaraints[0].spec.size ||
                  acc[item.id].sortedProductVaraints[0].spec.color ||
                  acc[item.id].sortedProductVaraints[0].spec.type)

          acc[item.id].totalCost += item.cost ? parseFloat(item.cost) : 0
          acc[item.id].totalQuantity = acc[
            item.id
          ].sortedProductVaraints.reduce((total, item) => {
            return Number(total) + Number(item.inventoriesCount)
          }, 0)
          return acc
        }, {})
      )
      return groupedInventoryList
    },
    ...mapState({
      loadingProductInventory: state => state.inventory.loadingProductInventory,
      productinventoryList: state => state.inventory.productInventoryList,
      isReplenishProducts: state => state.inventory.isReplenishProducts,
      searchTerm: state => state.globalTracking.searchTerm,
      team: state => state.team,
      totalRecords: state => state.inventory.totalCount,
      stockThresholdValue: state => state.inventory.stockThresholdValue,
      stockThresholdLimit: state => state.team.team.stockThresholdLimit
    }),
    hasThresholdValue() {
      return this.stockThresholdValue > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.button-gemnote-light {
  background: #f5f2ee;
  color: #24292c;
  width: auto;
  padding: 0 1.25rem;
  height: 2.5rem;
  padding: 0 1.25rem !important;
  border-radius: 40px;
  text-transform: uppercase;
  font-family: 'Inter', sans-serif;

  &:hover {
    background: #f5f2ee;
    color: #24292c;
  }
}

h5 {
  margin: 3rem;
}

.image-holder {
  display: flex;
  width: 50%;
  justify-content: center;

  .product-icon {
    height: 45px;
    object-fit: contain;
    padding: 0px 15px;
  }
}

.danger-color {
  color: #ce3c3c;
}

.variant-name {
  display: flex;
  gap: 12px;

  p {
    font-weight: 400;
    font-size: 0.813rem;
  }

  span {
    font-size: 14px;
    text-transform: capitalize;
    opacity: 0.5;
  }
}

.inventory-buttons {
  margin: 1rem 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /* Keep this unless it's causing issues */
}

.inventory-buttons button {
  height: 2.5rem;
  min-width: 100px;
  /* Set a minimum width to prevent shrinking */
  padding: 0 1rem;
  box-sizing: border-box;
  /* Ensures padding is part of width */
  z-index: 10;
  /* Brings button to the top if there's an overlap */
  position: relative;
  /* Allows z-index to work if needed */
  margin-left: 2rem;
  /* Optional: can be used instead of gap if gap causes issues */
}
.stock-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.stock-label {
  padding: 12px !important;
}

.stock-input {
  width: 100px;
}
</style>
